export {FilesEvent as default};

/**
* Files Event
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FilesEvent {
  /**
   * Files Data
   *
   * @public
   *
   * @type {Array<File>}
   *
   * @since 7.0.0
   */
  items = [];

  /**
   * Files Total Size
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  size = 0;
}